import { IUserState, UserActions } from "./user.interface";

export function setUser(user: IUserState){
  return {
    type: UserActions.SET_USER,
    payload: { user }
  }
}

export function loadUser(){
  return {
    type: UserActions.LOAD_USER
  }
}

export function logout(){
  localStorage.clear();
  return {
    type: UserActions.LOGOUT
  }
}

export function userDisconected(){
  return {
    type: UserActions.USER_DISCONECTED
  }
}

export function errorUser(){
  return {
    type: UserActions.ERROR_REQUEST
  }
}

export function setTheme(id:number,theme:string){
  return {
    type: UserActions.SET_THEME,
    payload: {user:{id,theme}}
  }
}

//SET_LANGUAGE
export function setLanguage(id:number,language:string){
  return {
    type: UserActions.SET_LANGUAGE,
    payload: {user:{id,language}}
  }
}